module.exports = __webpack_public_path__ + "img/be3ecc96878eed3223a7954ab84c4737.cfcd8b57.png";